//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import hsbCorrection from "apis/hsbPointsCorrection/hsbPointsCorrection";
import { mpcStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import { exportHeaders } from "./export";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";


// material-ui icons
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";

import { useTranslation } from 'react-i18next';
import { dateAndTimeFormat } from "helpers/dataFormat"


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { gethsbCorrection, search, hsbExport } =
  hsbCorrection();
  const { getAudit } = audit();

  const classes = mpcStyles();

  const [hsbData, setHsbData] = useState([]);
  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    orgName: "",
    isActive: "",
    allowPoints: "",
    allowTier: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "HSB POINTS CORRECTION"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetMpc();
    }
  }, [state.userInfo, offset]);

  // mpc api func
  const handleGetMpc = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await gethsbCorrection(values);
      if (res) {
        setHsbData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };




  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // search api func
  const handleSearch = async () => {
   
    setResponse({ ...response, filter: false });
    setFilterCard(false);
    setSelectedOrg({});
    setSelectedSales({});
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setHsbData(res.data);
        setCount(res.count);
        return;
      }
      setHsbData([]);
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };
  
  const pointsFormat = (value) => {
    if (value) {
      var nfObject = new Intl.NumberFormat("en-US");
      var points = nfObject.format(value);
      return points;
    }
    return "";
  };

  // filter api func
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (states.salesCategory) {
        values = { ...values, salesCategory: states.salesCategory };
      }
      if (states.redemptionFrom && states.redemptionTo) {
        values = {
          ...values,
          redemptionFrom: states.redemptionFrom,
          redemptionTo: states.redemptionTo,
        };
      }
      if (states.orgName) {
        values = { ...values, orgName: states.orgName };
      }
      if (typeof states.isActive === "boolean") {
        values = { ...values, isActive: states.isActive };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      // let res = await mpcFilter(values);
      let res = false
      if (res) {
        setHsbData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // export api function
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }
    
    dispatch({ type: "SET_LOADING", payload: true });
  
    let res = await hsbExport(values);
    if (res && res.data) {
     
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            order_line_number: obj?.order_line_number + String.fromCharCode(8203),
            order_id: obj?.order_id + String.fromCharCode(8203),
            order_number: obj?.order_number + String.fromCharCode(8203),
            points:pointsFormat(obj?.points),
            New_points:pointsFormat(obj?.New_points),
            difference:pointsFormat(obj?.difference),
            updated_on: dateAndTimeFormat(obj?.updated_on, i18n.language)
         

          }
        }));

      
    
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
  const tableHeading = [
    "Loyalty ID",
    "Billto",
    "Shipto",
    "Order Number",
    "Order ID",
    "Order Line Number",
    "Old Points",
    "New Points",
    "Difference Points",
    "View detail",
    // state?.userInfo?.auditAccess&& "History",
  ]; 

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]

  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid
        container
        spacing={0}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>{t('HSB Points Correction')}</span>
          </Grid>
        )}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 0.99 }}>
            <CssTextField
              placeholder={t('Search for Loyalty ID or Shipto or Order ID or Order Number')}
              type={"text"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGetMpc();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGetMpc();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
            {/* <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                if (!states.filter) {
                  setStates({
                    salesCategory: "",
                    redemptionFrom: null,
                    redemptionTo: null,
                    orgName: "",
                  });
                }
              }}
            >
              {t('Filter')}
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button> */}
          </div>
          <CSVLink
            id="csv"
            data={exportData}
            headers={exportHeaders          
            }
            filename={
              `HSB Correction` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={isLoading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
      </Grid>

      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={tableHeading.map((i) => (
                  <div key={t(i)}
                    className={i === "Org name" ? classes.orgNameColumn : null}
                  >
                    {t(i)}
                  </div>
                ))}
                data={hsbData.map((p, i) => [
                  p?.loyalty_id,
                  p?.customer_billto_account_number,
                  p?.customer_account_number,
                  p?.order_number,
                  p?.order_id,
                  p?.order_line_number,
                  p?.points?pointsFormat(p?.points):0,
                  p?.New_points?pointsFormat(p?.New_points):0,
                  p?.difference?pointsFormat(p?.difference):0,                  
                    
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/hsb-points-correction-detail", {
                          mpcId: p?.transaction_id,
                          offset,
                        });
                      }}
                    />,
                  ],
                  // state?.userInfo?.auditAccess && (
                  //   <HistoryIcon
                  //     key={i}
                  //     style={{ cursor: "pointer" }}
                  //     onClick={() => {
                  //       setStates({
                  //         historyDialog: true,
                  //         historyLoader: true,
                  //       });
                  //       handleGetHistoryData(p?.product_primary_class_id);
                  //     }}
                  //   />
                  // ),
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </div>
          </Grid>
        </Grid>
      </Loader>

      {/* history */}
      {/* <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog> */}
    </React.Fragment>
  );
}
